// extracted by mini-css-extract-plugin
export var numpadContainer = "_q7-1";
export var phoneButton = "_q7-0";